import axios from "axios";
import { parseMoney } from "./money";

function normalizeCollection(data) {
  if (Array.isArray(data)) return data;
  return Array.isArray(data?.results) ? data.results : [];
}

export async function resolveAuthenticatedUser(apiUrl, user) {
  if (!user?.nombre) throw new Error("No hay una sesión de usuario válida.");
  if (user.id) return user;

  // El endpoint de usuarios no implementa de forma fiable el filtro `search`.
  // Se consulta la colección y se resuelve la identidad de forma estricta en cliente.
  const response = await axios.get(`${apiUrl}/usuarios/`);
  const matches = normalizeCollection(response.data).filter(
    (candidate) => candidate.nombre === user.nombre
  );

  if (matches.length !== 1) {
    throw new Error(
      matches.length === 0
        ? "No se encontró el usuario autenticado."
        : "El nombre del usuario autenticado no es único."
    );
  }
  return { ...user, ...matches[0] };
}

export async function getUniqueActiveCashbox(apiUrl, userOrEmployeeId) {
  const employeeId =
    typeof userOrEmployeeId === "object"
      ? (await resolveAuthenticatedUser(apiUrl, userOrEmployeeId)).id
      : userOrEmployeeId;
  if (!employeeId) throw new Error("No se pudo identificar al usuario autenticado.");

  const response = await axios.get(`${apiUrl}/cajas/`, {
    params: { empleado_id: employeeId, estado: true },
  });
  const cashboxes = normalizeCollection(response.data);

  if (cashboxes.length === 0) {
    throw new Error("No hay una caja activa para el usuario.");
  }
  if (cashboxes.length > 1) {
    throw new Error("El usuario tiene más de una caja activa. Cierre las cajas duplicadas antes de continuar.");
  }
  return cashboxes[0];
}

export async function getUniqueCashboxForMovement(apiUrl, movementId) {
  const response = await axios.get(`${apiUrl}/cajas/`, {
    params: { movimiento: movementId },
  });
  const cashboxes = normalizeCollection(response.data);
  if (cashboxes.length !== 1) {
    throw new Error(
      cashboxes.length === 0
        ? "No se encontró la caja asociada al movimiento."
        : "El movimiento está asociado a más de una caja."
    );
  }
  return cashboxes[0];
}

export async function attachIncomeToCashbox(apiUrl, cashboxId, movementId, amount) {
  const latestResponse = await axios.get(`${apiUrl}/cajas/${cashboxId}/`);
  const latest = latestResponse.data;
  if (!latest.estado) throw new Error("La caja fue cerrada durante la operación.");

  const movementIds = [...new Set([...(latest.movimientos || []), movementId])];
  const total = parseMoney(parseMoney(latest.total_ingresos) + parseMoney(amount));

  const response = await axios.put(`${apiUrl}/cajas/${cashboxId}/`, {
    nombre: latest.nombre,
    movimientos: movementIds,
    total_ingresos: total,
  });
  return response.data;
}

export async function rollbackMovement(apiUrl, movementId) {
  if (!movementId) return;
  try {
    await axios.delete(`${apiUrl}/movimiento/${movementId}/`);
  } catch (error) {
    console.error("No se pudo revertir el movimiento incompleto:", error);
  }
}
